<template>
  <div class="page_boardgames">
    <h1>Deskovky</h1>
    <tabloid name="boardgames" :columns="columns" :data="data" defaultOrderBy="categoryAge">
      <template v-slot:name="{ value }">{{ value }}</template>
      <template v-slot:categoryAge="{ row }">{{ row.categoryId | cz }}</template>
      <template v-slot:players="{ row }">
        <div v-for="(boardgameParticipant, boardgameParticipantId) in row.players" :key="boardgameParticipantId" class="players">
          <i
            class="fa fa-times"
            :class="{ disabled: isChangeNotAllowed }"
            @click="removePlayer(boardgameParticipantId)"
            title="Odebrat"
          />
          <span>{{ boardgameParticipant.participant | participant_name }}</span>
        </div>
        <dropdown
          @change="player => addPlayer(player, row.id)"
          :items="row.availablePlayers"
          :disabled="isChangeNotAllowed"
          class="add"
        >
          <template v-slot:label>
            <i class="fas fa-plus"></i>
          </template>
          <template v-slot:item="props">{{ props.item | participant_name }}</template>
        </dropdown>
      </template>
    </tabloid>
  </div>
</template>

<script>
import { _ } from "../extend";
import { data } from "../store_utils";
import tabloid from "../components/tabloid";
import dropdown from "../components/dropdown";

export default {
  name: "boardgames",
  components: {
    tabloid,
    dropdown,
  },
  data: () => ({
    columns: {
      name: { title: "Název hry" },
      categoryAge: { title: "Kategorie" },
      players: { title: "Hráči" },
    },
  }),
  computed: {
    data() {
      const participants = _.select(this.$store.state.boardgameParticipants, bp => ({ ...bp, participant: this.$store.state.participants[bp.participantId] }));
      const participantGrouped = _.groupBy(participants, bp => bp.boardgameCategoryId);
      const boardgamesFilled = _.select(this.$store.state.boardgameCategories, c => ({
        ...c,
        categoryAge: this.$store.state.categories[c.categoryId].ageAtSeptemberMin,
        players: participantGrouped[c.id],
        availablePlayers: _.filter(
          this.$store.getters.myPlayingParticipant,
          participant =>
            !_.any(participantGrouped[c.id], bp => bp.participantId == participant.id) &&
            this.$store.state.childCategories[c.categoryId].includes(participant.categoryId)),
      }));
      
      return boardgamesFilled;
    },
    isChangeNotAllowed() {
      return false;
    },
  },
  methods: {
    addPlayer(player, boardgameCategoryId) {
      const boardgameParticipantId = data.newGuid();
      const value = {
        id: boardgameParticipantId,
        boardgameCategoryId,
        participantId: player.id,
      };
      this.$store.commit("add", {
        paths: ["boardgameParticipants", boardgameParticipantId],
        value
      });
    },
    removePlayer(boardgameParticipantId) {
      this.$store.commit("remove", {
        paths: ["boardgameParticipants", boardgameParticipantId],
      });
    }
  }
}
</script>

<style lang="sass">
@import ../sass/_components
.page_boardgames
  @include table-view()
  
  .players
    padding: .5rem
    i.fa-times
      margin: 0 5px
      cursor: pointer
      &.disabled
        cursor: not-allowed
</style>